import angular from '../../assets/technologies/angular.svg';
import bitbucket from '../../assets/technologies/bitbucket.svg';
import bootstrap from '../../assets/technologies/bootstrap.svg';
import css3 from '../../assets/technologies/css.svg';
import dotnet from '../../assets/technologies/dotnet.svg';
import figma from '../../assets/technologies/figma.svg';
import git from '../../assets/technologies/git.svg';
import github from '../../assets/technologies/github.svg';
import gitlab from '../../assets/technologies/gitlab.svg';
import html5 from '../../assets/technologies/html.svg';
import javascript from '../../assets/technologies/javascript.svg';
import mongodb from '../../assets/technologies/mongodb.svg';
import mysql from '../../assets/technologies/mysql.svg';
import nextjs from '../../assets/technologies/nextjs.svg';
import nodejs from '../../assets/technologies/nodejs.svg';
import nuxtjs from '../../assets/technologies/nuxtjs.svg';
import postgres from '../../assets/technologies/postgresql.svg';
import react from '../../assets/technologies/react.svg';
import sass from '../../assets/technologies/sass.svg';
import sqlserver from '../../assets/technologies/sqlserver.svg';
import tailwindcss from '../../assets/technologies/tailwindcss.svg';
import typescript from '../../assets/technologies/typescript.svg';
import vscode from '../../assets/technologies/vs-code.svg';
import vue from '../../assets/technologies/vue.svg';

export const iconsData = [
  {
    icon: react,
    name: 'React',
  },
  {
    icon: angular,
    name: 'Angular',
  },
  {
    icon: vue,
    name: 'Vue',
  },
  {
    icon: nextjs,
    name: 'NextJS',
  },
  {
    icon: nuxtjs,
    name: 'NuxtJS',
  },
  {
    icon: html5,
    name: 'HTML5',
  },
  {
    icon: css3,
    name: 'CSS3',
  },
  {
    icon: javascript,
    name: 'JavaScript',
  },
  {
    icon: typescript,
    name: 'TypeScript',
  },
  {
    icon: tailwindcss,
    name: 'TailwindCSS',
  },
  {
    icon: bootstrap,
    name: 'Bootstrap',
  },
  {
    icon: sass,
    name: 'SASS',
  },
  {
    icon: nodejs,
    name: 'NodeJS',
  },
  {
    icon: dotnet,
    name: '.NET',
  },
  {
    icon: mongodb,
    name: 'MongoDB',
  },
  {
    icon: mysql,
    name: 'MySQL',
  },
  {
    icon: postgres,
    name: 'Postgres',
  },
  {
    icon: sqlserver,
    name: 'SQL Server',
  },
  {
    icon: git,
    name: 'Git',
  },
  {
    icon: github,
    name: 'GitHub',
  },
  {
    icon: bitbucket,
    name: 'Bitbucket',
  },
  {
    icon: gitlab,
    name: 'GitLab',
  },
  {
    icon: figma,
    name: 'Figma',
  },
  {
    icon: vscode,
    name: 'Visual Studio Code',
  },
];
